import {
  AggregateBorrowingRiskChartData,
  PortfolioChartComponentType,
  PortfolioChartConfig,
} from '../shared/portfolioChartUtils';
import { colors, transparency } from 'packages/common-frontend/colors';

const addTransparencyToColor = (color: string) => `${color}${transparency[50]}`;

export const generateLtvChartConfig = ({
  chartComponentType,
}: {
  chartComponentType: PortfolioChartComponentType;
}): PortfolioChartConfig<keyof AggregateBorrowingRiskChartData> => {
  return {
    collateralCovenantLtv: {
      chartType: chartComponentType,
      field: 'collateralCovenantLtv',
      label: 'Collateral Covenant LTV',
      format: 'percentage',
      color:
        chartComponentType === 'bar'
          ? addTransparencyToColor(colors.chart.paleViolet)
          : colors.chart.paleViolet,
      activeColor: colors.chart.paleViolet,
    },
    netOutstandingLtv: {
      chartType: chartComponentType,
      field: 'netOutstandingLtv',
      label: 'Net Outstanding LTV',
      format: 'percentage',
      color:
        chartComponentType === 'bar'
          ? addTransparencyToColor(colors.chart.winter)
          : colors.chart.winter,
      activeColor: colors.chart.winter,
    },
    performingLtv: {
      chartType: chartComponentType,
      field: 'performingLtv',
      label: 'Performing LTV',
      format: 'percentage',
      color:
        chartComponentType === 'bar'
          ? addTransparencyToColor(colors.chart.pink)
          : colors.chart.pink,
      activeColor: colors.chart.pink,
    },
  };
};
